angular.module('admin.groups', [
  'admin.groups.index',
  'admin.groups.add',
  'admin.groups.detail'
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/groups/index.js